import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import {authStore} from "./modules/auth/index";
import {gameStore} from "./modules/game/index";
import {addressStore} from "@/stores/modules/address";


export default new Vuex.Store({
    modules: {
        auth: authStore,
        game: gameStore,
        address: addressStore
    }
});
